<template>
    <div id="resaneh-details-container">
        <router-view class="main"></router-view>
    </div>
</template>

<script>
export default {
    name: 'resaneh',
    data() {
        return {
        }
    }
}
</script>

<style scoped>
/* ----------------------------------- */
/* ------------ Container ------------ */
/* ----------------------------------- */
#resaneh-details-container {
    height: 100%;
    width: 100%;
}
#resaneh-details-container .main {
    padding-top: 0pt;
}
</style>